// extracted by css-extract-rspack-plugin
export default {"SidebarActions":"SidebarActions-module__SidebarActions__GYFYx"};